import { Spin } from 'antd';
import styled from 'styled-components';

export const SpinStyle = styled(Spin)`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.ant-spin-nested-loading {
    height: 100%;
    width: 100%;
  }
`;
